<template>
  <a-layout-sider
    :width="settings.leftMenuWidth"
    :collapsible="settings.isMobileView ? false : true"
    :collapsed="settings.isMenuCollapsed && !settings.isMobileView"
    @collapse="onCollapse"
    :class="{
      [$style.menu]: true,
      [$style.white]: settings.menuColor === 'white',
      [$style.gray]: settings.menuColor === 'gray',
      [$style.dark]: settings.menuColor === 'dark',
      [$style.unfixed]: settings.isMenuUnfixed,
      [$style.shadow]: settings.isMenuShadow,
    }"
  >
    <div
      :class="$style.menuOuter"
      :style="{
        width: settings.isMenuCollapsed && !settings.isMobileView ? '80px' : settings.leftMenuWidth + 'px',
        height: settings.isMobileView || settings.isMenuUnfixed ? 'calc(100% - 64px)' : 'calc(100% - 110px)',
      }"
    >
      <div :class="$style.logoContainer">
        <div :class="$style.logo">
          <img src="taxi-logo.png" style="max-width:80%;height:auto;" class="mr-2 inline" alt="Taxi Contigo" />
          <!--
          <div :class="$style.name">{{ settings.logo }}</div>
          <div v-if="settings.logo === 'Clean UI Pro'" :class="$style.descr">Vue</div>
          -->
        </div>
      </div>
      <vue-custom-scrollbar
      :style="{
          height: '100%',
          overflow: 'auto',
        }"
        class="scroll-area" :settings="sett"
      >
        <a-menu
          forceSubMenuRender
          :inlineCollapsed="settings.isMobileView ? false : settings.isMenuCollapsed"
          :mode="'inline'"
          :selectedKeys="selectedKeys"
          :openKeys.sync="openKeys"
          @click="handleClick"
          @openChange="handleOpenChange"
          :inlineIndent="15"
          :class="$style.navigation"
        >
          <template v-for="(item, index) in menuData">
            <template v-if="!item.roles || item.roles.includes(user.role)">
              <a-menu-item-group :key="index" v-if="item.category">
                <template slot="title">{{ item.title }}</template>
              </a-menu-item-group>
              <item
                v-if="!item.children && !item.category"
                :menu-info="item"
                :styles="$style"
                :key="item.key"
              />
              <sub-menu v-if="item.children" :menu-info="item" :styles="$style" :key="item.key" />
            </template>
          </template>
        </a-menu>
      </vue-custom-scrollbar>
    </div>
  </a-layout-sider>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from 'store'
import find from 'lodash/find'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { getMenuData } from '@/services/menu'
import SubMenu from './partials/submenu'
import Item from './partials/item'
import * as firebase from 'firebase/app'
export default {
  name: 'menu-left',
  components: { vueCustomScrollbar, SubMenu, Item },
  computed: {
    ...mapState(['settings']),
    ...mapGetters('user', ['user']),
  },
  mounted() {
    this.openKeys = store.get('app.menu.openedKeys') || []
    this.selectedKeys = store.get('app.menu.selectedKeys') || []
    this.setSelectedKeys()
  },
  data() {
    return {
      sett: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      menuData: [], // getMenuData,
      selectedKeys: [],
      openKeys: [],
    }
  },
  watch: {
    'settings.isMenuCollapsed'() {
      this.openKeys = []
    },
    '$route'() {
      this.setSelectedKeys()
    },
  },
  async beforeCreate() {
    console.log('BEFORE CREATE ===============', this.$store.state)
    const documents = await firebase.firestore().collection('roles').doc(this.$store.state.user.role).get()
    console.log('documents ======> ', documents.data())
    Object.entries(documents.data()).forEach(document => {
      getMenuData.forEach(item => {
        if (item.category) {
          if (item.title === document[0]) {
            item.roles = []
            item.roles.push(this.$store.state.user.role)
            console.log('item ======> ', item)
            this.menuData.push(item)
          }
        } else {
          const section = {
            title: item.title,
            key: item.key,
            icon: item.icon,
            count: item.count,
            children: [],
          }
          item.children.forEach(itemChildren => {
            document[1].forEach(documentChildren => {
              if (itemChildren.title === documentChildren) {
                itemChildren.roles = []
                itemChildren.roles.push(this.$store.state.user.role)
                section.children.push(itemChildren)
              }
            })
          })
          if (section.children.length > 0) {
            this.menuData.push(section)
          }
        }
      })
    })
    this.menuData.sort(function (a, b) {
      if (a.title > b.title) {
        return 1
      }
      if (a.title < b.title) {
        return -1
      }
      // a must be equal to b
      return 0
    })
    console.log(this.menuData)
  },
  methods: {
    onCollapse: function (collapsed, type) {
      const value = !this.settings.isMenuCollapsed
      this.$store.commit('CHANGE_SETTING', { setting: 'isMenuCollapsed', value })
    },
    handleClick(e) {
      if (e.key === 'settings') {
        this.$store.commit('CHANGE_SETTING', { setting: 'isSettingsOpen', value: true })
        return
      }
      store.set('app.menu.selectedKeys', [e.key])
      this.selectedKeys = [e.key]
    },
    handleOpenChange(openKeys) {
      store.set('app.menu.openedKeys', openKeys)
      this.openKeys = openKeys
    },
    setSelectedKeys() {
      const pathname = this.$route.path
      const menuData = this.menuData.concat()
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item)
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key))
          }
          return flattenedItems
        }, [])
      const selectedItem = find(flattenItems(menuData, 'children'), [
        'url',
        pathname,
      ])
      this.selectedKeys = selectedItem ? [selectedItem.key] : []
    },
  },
  created() {
    console.log(getMenuData)
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";

.scroll-area {
  position: relative;
  margin: auto;
  width: 600px;
  height: 400px;
}

</style>
